import UsersRepository from '@/models/UsersRepository.js'
import PostsRepository from '@/models/PostsRepository.js'

export const REPOSITORIES = Object.entries({
  postsRepository: PostsRepository,
  usersRepository: UsersRepository,
})
